<template>
<div>

  <Drawer :mask-closable="false" @on-close="handleReset('addressForm')" title="Add Address"
          v-model="addAddressDrawer" width="620">
    <Row>
      <Col span="24">
        <Form :model="addressForm" :rules="addressRuleValidate" label-position="top" ref="addressForm">
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="Address 1" prop="add1">
                <Input placeholder="Enter your Address" v-model="addressForm.add1"></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="Address 2" prop="add2">
                <Input placeholder="Enter your Address" v-model="addressForm.add2"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="City" prop="city" v-if="addAddressDrawer">
                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter}">
                  <template slot-scope="{ result: { loading, error, data } }">
                    <div v-if="loading"> Loading...</div>
                    <div v-else-if="error"> Error Occured. {{error}}</div>
                    <div v-else-if="data">
                      <AutoComplete placeholder="Search City"
                                    v-model="addressForm.city">
                        <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data.city">
                          <div @click="addressForm.state=cityObj.state;selectedCityId=cityObj.id">{{cityObj.city}}</div>
                        </Option>
                      </AutoComplete>
                    </div>
                    <div v-else>
                      There are no City Available yet.
                    </div>
                  </template>
                </ApolloQuery>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="State" prop="state" v-if="addAddressDrawer">
                <ApolloQuery :query="query_SEARCH_STATE" :variables="{stateFilter}">
                  <template slot-scope="{ result: { loading, error, data } }">
                    <div v-if="loading"> Loading...</div>
                    <div v-else-if="error"> Error Occured. {{error}}</div>
                    <div v-else-if="data">
                      <AutoComplete placeholder="Search State"
                                    v-model="addressForm.state">
                        <Option :key="index" :value="stateObj.state" v-for="(stateObj,index) in data.territories">
                          {{stateObj.state}}
                        </Option>
                      </AutoComplete>
                    </div>
                    <div v-else>
                      There are no State Available yet.
                    </div>
                  </template>
                </ApolloQuery>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="Area" prop="area">
                <Select v-model="addressForm.area" filterable>
                  <Option v-for="(area,index) in areaArr" :value="area.area"
                          :label="area.area" :key="index">
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="PIN" prop="pincode">
                <Input type="number" placeholder="Enter your PIN" v-model="addressForm.pincode"></Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
    <Button @click="handleAddAddress()" color="primary" :loading="loader">Add</Button>
  </Drawer>
  <Drawer :mask-closable="false" @on-close="handleReset('contactForm')" title="Add Contact"
          v-model="addContactDrawer" width="620">
    <Row>
      <Col span="24">
        <Form :model="contactForm" :rules="contactRuleValidate" label-position="top" ref="contactForm">
          <FormItem label="Type" prop="type">
            <RadioGroup v-model="contactForm.role">
              <Radio label="1"><span>Marketing</span></Radio>
              <Radio label="2"><span>Dispatch</span></Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="Contact Name" prop="name">
            <Input :maxlength="30" v-model="contactForm.name"/>
          </FormItem>
          <FormItem label="Mobile Number" prop="mobile">
            <Input type="number" v-model="contactForm.mobile"/>
          </FormItem>
          <FormItem label="Email" prop="email">
            <Input v-model="contactForm.email"/>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Button @click="handleAddContact()" color="primary" :loading="loader">Add</Button>
  </Drawer>
  <Drawer :mask-closable="false" @on-close="handleReset('companyUserForm')" title="Add Company User"
          v-model="addCompanyUserDrawer" width="620">
    <Row>
      <Col span="24">
        <Form :model="companyUserForm" :rules="companyUserRuleValidate" label-position="top" ref="companyUserForm">
          <!--                    <FormItem label="Type" prop="type">-->
          <!--                        <RadioGroup v-model="companyUserForm.role">-->
          <!--                            <Radio label="1"><span>Marketing</span></Radio>-->
          <!--                            <Radio label="2"><span>Dispatch</span></Radio>-->
          <!--                        </RadioGroup>-->
          <!--                    </FormItem>-->
          <FormItem label="User Name" prop="name">
            <Input :maxlength="30" v-model="companyUserForm.name"/>
          </FormItem>
          <FormItem label="Mobile Number" prop="mobile">
            <Input type="number" v-model="companyUserForm.mobile"/>
          </FormItem>
          <FormItem label="Email" prop="email">
            <Input v-model="companyUserForm.email"/>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Button @click="handleAddCompanyUser()" color="primary" :loading="loader">Add</Button>
  </Drawer>

</div>
</template>

<script>
    import ValidationRules from "../../Constants/ValidationRules";
    import {GET_AREAS_BY_CITY} from "../../graphql/queries/area";
    import {GET_ALL_CITIES, SEARCH_CITY2, SEARCH_STATE} from "../../graphql/queries/territories";
    import {generate_DELETE_CLIENT_DATA, generate_INSERT_CLIENT_DATA} from "../../graphql/mutations/companies";
    import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders";
    import {GET_COMPANY_USER_BY_MOBILE} from "../../graphql/queries/contacts";

    export default {
        apollo: {
          area: {
            query: GET_AREAS_BY_CITY,
            variables() {
              return {
                cityId: this.selectedCityId,
              }
            },
            result({data, loading}) {
              if (!loading) {
                this.areaArr = data.area;
              }
            }
          },
      },
        name: "UpdateDetail",
        data: function(){
          let self = this
          return{
            query_SEARCH_CITY: SEARCH_CITY2,
            query_SEARCH_STATE: SEARCH_STATE,
            addAddressDrawer: false,
            addressForm: {
              add1: '',
              add2: '',
              area: '',
              pincode: null,
              city: null,
              state: null
            },
            addressRuleValidate: {
              add1: ValidationRules.add2, area: ValidationRules.area,
              city: ValidationRules.city, state: ValidationRules.state
            },
            addContactDrawer: false,
            contactForm: {
              role: '1',
              name: '',
              mobile: '',
              email: ''
            },
            contactRuleValidate: {
              name: [{ required: true, message: 'Enter name', trigger: 'blur' }],
              email: [{ type: 'email', message: 'Incorrect email format', trigger: 'change' }],
              mobile: [{ validator: self.validateMobile, trigger: 'change' }]
            },
            selectedCityId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
            areaArr: [],
            loader: false,
            addCompanyUserDrawer: false,
            companyUserForm: {
              role: '1',
              name: '',
              mobile: '',
              email: ''
            },
            companyUserRuleValidate: {
              name: [{ required: true, message: 'Enter name', trigger: 'blur' }],
              email: [{ type: 'email', message: 'Incorrect email format', trigger: 'change' }],
              mobile: [{ validator: self.validateMobile, trigger: 'change' }]
            },
            addressArr: [],
            contactId: '',
            companyUserId: '',
            existingUserMobile: '',
            addressIndex: ''
          }
        },
      methods: {
        handleReset (name) {
          this.$refs[name].resetFields()
          this.addressArr = [];
          this.contactId = '';
          this.companyUserId = '';
          this.addressIndex = '';
        },
        onEditContact(contact){
          this.contactForm.role = contact.role.toString()
          this.contactForm.name = contact.name
          this.contactForm.email = contact.email
          this.contactForm.mobile = parseInt(contact.mobile)
          this.contactId = contact.id
          this.addContactDrawer = true
        },
        onEditCompanyUser(user){
          this.companyUserForm.role = user.role.toString()
          this.companyUserForm.name = user.name
          this.companyUserForm.email = user.email
          this.companyUserForm.mobile = Number(user.mobile)
          this.existingUserMobile = JSON.stringify(JSON.parse(user.mobile));
          this.companyUserId = user.id
          this.addCompanyUserDrawer = true
        },
        async onEditAddress(address, index){
          this.addressForm.add1 = address.add1
          this.addressForm.add2 = address.add2
          this.addressForm.pincode = address.pincode
          this.addressForm.state = address.state
          this.addressForm.city = address.city
          this.addressForm.area = address.area
          this.addressIndex = index
          this.addAddressDrawer = true

        /* ----- Retrieve all cities for retrieving areas by cityId and to autofill area ----- */
          let response = await this.$apollo.query({
            query: GET_ALL_CITIES,
            fetchPolicy: 'network-only',
          })
          if(response.data.city.length){
            let matchedObj = response.data.city.find(({city}) => city === address.city);
            this.selectedCityId = matchedObj ? matchedObj.id : this.selectedCityId;
          }
        /* ----------------x---------------x---------------x-----------------x----------------- */
        },
        handleAddAddress(){
          this.$refs['addressForm'].validate((valid) => {
            if (valid) {

              if(this.addressIndex || this.addressIndex === 0){
                this.addressArr[this.addressIndex] = this.addressForm;
              }else{
                this.addressArr.push(this.addressForm);
              }

              let obj = { address: this.addressArr };
              let id = this.$route.params.id;
              this.updateRecord(id, obj, 'company','addAddressDrawer', 'addressForm')
            }else{
              this.$Message.error('Fail to add Address')
            }
          })
        },
        handleAddContact(){
          this.$refs['contactForm'].validate((valid) => {
            if (valid) {
                let obj = {
                  ...this.contactForm,
                  clientid: this.$route.params.id,
                  mobile: Number(this.contactForm.mobile),
                  role: Number(this.contactForm.role)
                }

                if(this.contactId){              //Edit contact
                  this.updateRecord(this.contactId, obj, 'contacts', 'addContactDrawer', 'contactForm')
                }else{                            //Add contact
                  obj.id = this.generateUUID();
                  this.insertRecord(obj, 'contacts','addContactDrawer', 'contactForm')
                }

            }else{
              this.$Message.error('Fail to add Contact')
            }
          })
        },
        handleAddCompanyUser(){
          this.$refs['companyUserForm'].validate(async (valid) => {
            if (valid) {
              let response = await this.$apollo.query({
                query: GET_COMPANY_USER_BY_MOBILE,
                variables: {
                  mobileArr: [this.companyUserForm.mobile.toString()],
                }
              })
              if(response.data.companyUsers.length &&
                (!this.companyUserId||this.companyUserForm.mobile.toString()!==this.existingUserMobile.toString())){
                this.$Message.error('Mobile number already exists')
                return ;
              }

              let obj = {
                ...this.companyUserForm,
                clientid: this.$route.params.id,
                mobile: this.companyUserForm.mobile.toString(),
                role: Number(this.companyUserForm.role)
                }

                if(this.companyUserId){
                  this.updateRecord(this.companyUserId, obj, 'CompnayUser', 'addCompanyUserDrawer', 'companyUserForm')
                }else{                            //Add contact
                  obj.id = this.generateUUID();
                  this.insertRecord(obj, 'CompnayUser','addCompanyUserDrawer', 'companyUserForm')
                }

            }else{
              this.$Message.error('Fail to add Company User')
            }
          })
        },
        onDeleteCompanyUser(companyUserId){
          this.$Modal.confirm({
            title: 'Confirmation',
            content: '<p>Are You sure want to delete Company User ?</p>',
            loading: true,
            onOk: () => {
              this.deleteRecord(companyUserId, 'CompnayUser', this.$Modal)
            }
          });
        },
        onDeleteContact(contactId){
          this.$Modal.confirm({
            title: 'Confirmation',
            content: '<p>Are You sure want to delete Contact ?</p>',
            loading: true,
            onOk: () => {
              this.deleteRecord(contactId, 'contacts', this.$Modal)
            }
          });
        },
        onDeleteAddress(addressId, index){
          this.$Modal.confirm({
            title: 'Confirmation',
            content: '<p>Are You sure want to delete Address ?</p>',
            loading: true,
            onOk: () => {
              this.addressArr.splice(index, 1);
              let obj = { address: this.addressArr };
              let id = this.$route.params.id;
              this.updateRecord(id, obj, 'company','addAddressDrawer', 'addressForm')
              this.$Modal.remove();
            }
          });
        },
        deleteRecord(id, table, callback){
          this.$apollo.mutate({
            mutation: generate_DELETE_CLIENT_DATA(table),
            variables: { id: id }
          }).then(function(response){
            callback.remove();
            this.$Message.success(table + ' deleted successfully!');
          }).catch(function(err){
            callback.remove();
          })
        },
        async insertRecord(obj, table, drawer, ref){
          this.lodaer = true
          let response = await this.$apollo.mutate({
            mutation: generate_INSERT_CLIENT_DATA(table),
            variables: { obj: obj}
          })
          if(response.data){
            this.$Message.success('client detail updated successfully!')
            this.loader = false
            this[drawer] = false
            this.handleReset(ref);
          }
        },
        async updateRecord(id, obj, table, drawer, ref){
          console.log('update Record')
          this.loader = true
          let response = await this.$apollo.mutate({
            mutation: generate_UPDATE_ORDER_DATA(table),
            variables: { id: id, obj: obj}
          })
          if(response.data){
            this.$Message.success('client detail updated successfully!')
            this.loader = false
            this[drawer] = false
            this.handleReset(ref);
          }
        },
        validateMobile (rule, value, callback) {
          if (value && value.toString().length !== 10) {
            callback(new Error('Length Must be equal to 10 digit'))
          } else {
            callback()
          }
        },
        generateUUID () {
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
            return v.toString(16)
          })
        },
      },
      computed: {
        cityFilter () {
          return '%' + this.addressForm.city + '%'
        },
        stateFilter () {
          return '%' + this.addressForm.state + '%'
        }
      },
    }
</script>

<style scoped>

</style>
